import React, { lazy, Suspense } from 'react';
import {
	BrowserRouter as Router,
	Switch,
	Route,
	Redirect,
} from 'react-router-dom';
import Login from '../views/Login';
import AppDrawer from '../components/shared/AppDrawer';
import NotFound from '../components/errors/404';
import ServerError from '../components/errors/500';
import Loader from '../components/shared/Loader';
import { connect } from 'react-redux';

const Dashboard = lazy(() => import('../views/Dashboard'));
const Users = lazy(() => import('../views/Users'));
const Explore = lazy(() => import('../views/Explore'));
const BVNVerification = lazy(() => import('../views/BVNUsers'));

const Routes = ({ auth }) => {
	const withDrawer = (Component) => {
		return (
			<AppDrawer>
				<Suspense fallback={<Loader />}>
					<Component />
				</Suspense>
			</AppDrawer>
		);
	};

	const PrivateRoute = ({ component: Component, exact, ...rest }) => {
		// console.log("user: ", user);
		// if (!user) logout();
		const authenticated = auth.authenticated;
		return (
			<Route
				{...rest}
				render={(props) =>
					authenticated ? <Component {...props} /> : <Redirect to='/login' />
				}
				exact={exact}
			/>
		);
	};

	return (
		<Router>
			<Switch>
				<Route path='/login'>
					<Login />
				</Route>
				<PrivateRoute
					exact
					path='/'
					component={() => withDrawer(Dashboard)}
				/>
				<PrivateRoute
					exact
					path='/users'
					component={() => withDrawer(Users)}
				/>
				<PrivateRoute
					exact
					path='/verifiedshops'
					component={() => withDrawer(Explore)}
				/>
				<PrivateRoute
					exact
					path='/bvnusers'
					component={() => withDrawer(BVNVerification)}
				/>
				<Route path='/500'>
					<ServerError />
				</Route>
				<Route path='*'>
					<NotFound />
				</Route>
			</Switch>
		</Router>
	);
};

export default connect(({ auth }) => ({ auth }))(Routes);
